import { render, staticRenderFns } from "./JBICManagement.vue?vue&type=template&id=7d0caae2&"
import script from "./JBICManagement.vue?vue&type=script&lang=ts&"
export * from "./JBICManagement.vue?vue&type=script&lang=ts&"
import style0 from "./JBICManagement.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports